import React from 'react';
import LoadingOverlay from '../components/LoadingOverlay';

function ClientesDropdown({ isLoading = false }){
    return (
        <div style={{ position: 'relative' }}>
            <LoadingOverlay isLoading={isLoading} message="Carregando clientes..." />
            <div>Cliente</div>
        </div>
    )
}

export default ClientesDropdown;